import React from 'react';
import { SC } from '../../styles/theme';
import DealerPartExchangeTemplate from '@components/DealerPartExchange/PartExchangeTemplate';

export interface DealerPartExchangeProps extends SC {}

const DealerPartExchange = (props: DealerPartExchangeProps) => {
    return <DealerPartExchangeTemplate {...props} />;
};

export default DealerPartExchange;
